module.exports = __webpack_public_path__ + "static/media/Smiley_linkerarm_blij.7de79ae5.png";